// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j4-0";
export var actionModalContentContainer = "_j4-1";
export var createTagButton = "_j4-2";
export var footerContainer = "_j4-7";
export var fullWidthDivider = "_j4-3";
export var hasCreateTagButton = "_j4-4";
export var noCreateTagButton = "_j4-5";
export var tagsContainer = "_j4-6";
export var tagsModalContentContainer = "_j4-8";